import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Heading as ChakraHeading } from '@chakra-ui/react';
export function Heading(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ChakraHeading, _extends({
    color: "grey.900",
    fontFamily: "var(--chakra-fonts-heading) !important" // temporary overwrite due to presense of frontend-lib
    ,
    lineHeight: "1.14",
    fontWeight: "normal",
    textAlign: "inherit"
  }, props), children);
}